import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

export default function HomeButton() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleClick = () => {
    navigate(isAuthenticated ? '/home-dashboard' : '/');
  };

  return (
    <button
      onClick={handleClick}
      className="mt-8 px-8 py-3 rounded-xl font-semibold text-base transition-all duration-200"
      style={{
        backgroundColor: '#D4A520',
        color: '#0B1F3B',
        boxShadow: '0 0 0 0 rgba(212,165,32,0)',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.03)';
        e.currentTarget.style.boxShadow = '0 0 20px rgba(212,165,32,0.5)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 0 0 0 rgba(212,165,32,0)';
      }}
    >
      Back to Home
    </button>
  );
}
